module.exports = __webpack_public_path__ + "media/promo/panasonic/images/recipe-2d03f543c5b3df8a1ffb0bafc2ba00ba.jpg";